export default __webpack_public_path__ + "static/media/Y_Ybytu.b66b6793.mp3";